import { render, staticRenderFns } from "./fflearnerdetail.vue?vue&type=template&id=c96120da&"
import script from "./fflearnerdetail.vue?vue&type=script&lang=js&"
export * from "./fflearnerdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports